import React, { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import '../../styles/Sidebar.css';
import { FiCalendar, FiHome, FiLogOut, FiUser, FiChevronLeft, FiChevronRight } from "react-icons/fi";
import { PiDog } from "react-icons/pi";
import { OwnerContext } from "../../context/OwnerContext";
import { GiConfirmed } from "react-icons/gi";

const OwnerSidebar = ({ isCollapsed, onToggleCollapse, activeRoute }) => {
    const navigate = useNavigate();
    const { owner } = useContext(OwnerContext);

    // Helper function to check if route is active
    const isRouteActive = (route) => {
        if (!activeRoute || typeof activeRoute !== 'string') return false;
        if (Array.isArray(route)) {
            return route.some(r => activeRoute.includes(r));
        }
        return activeRoute.includes(route);
    };

    const handleLogout = () => {
        localStorage.removeItem('jwt');
        navigate('/');
    };

    // Safe display name handling
    let displayName = 'Owner';
    let nameInitial = 'O';

    try {
        if (owner && typeof owner === 'object') {
            if (owner.firstName && owner.lastName &&
                typeof owner.firstName === 'string' && typeof owner.lastName === 'string') {
                displayName = `${owner.firstName} ${owner.lastName}`;
            } else if (owner.username && typeof owner.username === 'string') {
                displayName = owner.username;
            }

            if (typeof displayName === 'string' && displayName.length > 0) {
                nameInitial = displayName.charAt(0).toUpperCase();
            }
        }
    } catch (error) {
        console.error('Error processing owner data:', error);
    }

    return (
        <aside className={`sidebar ${isCollapsed ? 'collapsed' : ''}`}>
            {/* Collapse/Expand Toggle Button */}
            <button
                className="collapse-toggle"
                onClick={onToggleCollapse}
                title={isCollapsed ? "Expand sidebar" : "Collapse sidebar"}
            >
                {isCollapsed ? <FiChevronRight /> : <FiChevronLeft />}
            </button>

            {!isCollapsed && (
                <>
                    <div className="profile-section">
                        <div className="profile-icon">
                            <span>{nameInitial}</span>
                        </div>
                        <p>{displayName}</p>
                    </div>
                    <nav className="nav-section">
                        <ul>
                            <li>
                                <button
                                    className={`nav-button ${isRouteActive('/owner/dashboard') ? 'active' : ''}`}
                                    onClick={() => navigate('/owner/dashboard')}
                                >
                                    <FiHome /> Dashboard
                                </button>
                            </li>
                            <li>
                                <button
                                    className={`nav-button ${isRouteActive('/owner/my-dog') ? 'active' : ''}`}
                                    onClick={() => navigate('/owner/my-dog')}
                                >
                                    <PiDog /> Mój pupil
                                </button>
                            </li>
                            <li>
                                <button
                                    className={`nav-button ${isRouteActive('/owner/trainings') ? 'active' : ''}`}
                                    onClick={() => navigate('/owner/trainings')}
                                >
                                    <GiConfirmed /> Moje treningi
                                </button>
                            </li>
                            <li>
                                <button
                                    className={`nav-button ${isRouteActive('/owner/calendar') ? 'active' : ''}`}
                                    onClick={() => navigate('/owner/calendar')}
                                >
                                    <FiCalendar /> Zapisy
                                </button>
                            </li>
                            <li>
                                <button
                                    className={`nav-button ${isRouteActive('/owner/account') ? 'active' : ''}`}
                                    onClick={() => navigate('/owner/account')}
                                >
                                    <FiUser /> Moje konto
                                </button>
                            </li>
                        </ul>
                    </nav>
                    <button className="logout-button" onClick={handleLogout}>
                        <FiLogOut className="logout-icon" /> Wyloguj się
                    </button>
                </>
            )}

            {/* Collapsed state - only show icons */}
            {isCollapsed && (
                <nav className="nav-section-collapsed">
                    <ul>
                        <li>
                            <button
                                className={`nav-button-collapsed ${isRouteActive('/owner/dashboard') ? 'active' : ''}`}
                                onClick={() => navigate('/owner/dashboard')}
                                title="Dashboard"
                            >
                                <FiHome />
                            </button>
                        </li>
                        <li>
                            <button
                                className={`nav-button-collapsed ${isRouteActive('/owner/my-dog') ? 'active' : ''}`}
                                onClick={() => navigate('/owner/my-dog')}
                                title="Mój pupil"
                            >
                                <PiDog />
                            </button>
                        </li>
                        <li>
                            <button
                                className={`nav-button-collapsed ${isRouteActive('/owner/trainings') ? 'active' : ''}`}
                                onClick={() => navigate('/owner/trainings')}
                                title="Moje treningi"
                            >
                                <GiConfirmed />
                            </button>
                        </li>
                        <li>
                            <button
                                className={`nav-button-collapsed ${isRouteActive('/owner/calendar') ? 'active' : ''}`}
                                onClick={() => navigate('/owner/calendar')}
                                title="Zapisy"
                            >
                                <FiCalendar />
                            </button>
                        </li>
                        <li>
                            <button
                                className={`nav-button-collapsed ${isRouteActive('/owner/account') ? 'active' : ''}`}
                                onClick={() => navigate('/owner/account')}
                                title="Moje konto"
                            >
                                <FiUser />
                            </button>
                        </li>
                    </ul>
                    <button
                        className="logout-button-collapsed"
                        onClick={handleLogout}
                        title="Wyloguj się"
                    >
                        <FiLogOut />
                    </button>
                </nav>
            )}
        </aside>
    );
};

export default OwnerSidebar;